export default __webpack_public_path__ + "static/media/ascent.d55a65a5.png";